import { IconWrapper } from '../runtime';
export default IconWrapper('play', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M15 7.99976C15 11.8657 11.866 14.9998 8 14.9998C4.13401 14.9998 1 11.8657 1 7.99976C1 4.13376 4.13401 0.999756 8 0.999756C11.866 0.999756 15 4.13376 15 7.99976Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  }), h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M5.99805 5.91936C5.99805 5.30352 6.66471 4.91862 7.19805 5.22654L10.798 7.305C11.3314 7.61292 11.3314 8.38272 10.798 8.69064L7.19805 10.7691C6.66471 11.077 5.99805 10.6921 5.99805 10.0763V5.91936Z",
      "fill": props.colors[0],
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});